export default class DDMDataLayerService {
  constructor() {
    this.channelName = this._getChannelName();
    this.defaultArea = 'Ofertas';
  }

  addViewItemListEvent(itemList) {
    if (itemList.length === 0) return;

    this._clearEcommerceKey();

    this._addEventToDataLayer({
      event: 'view_item_list',
      ecommerce: {
        item_list_id: 'carrossel_lp',
        item_list_name: 'Carrossel Landing Page',
        items: itemList.map(item => ({
          item_id: item.id,
          item_name: item.name,
          affiliation: this.channelName,
          item_brand: item.brand,
          item_category: item.category,
          item_category2: item.area || this.defaultArea,
          price: item.price,
        })),
      },
    });
  }

  addSelectItemEvent(item) {
    if (!item) return;

    this._clearEcommerceKey();

    this._addEventToDataLayer({
      event: 'select_item',
      ecommerce: {
        item_list_id: 'carrossel_lp',
        item_list_name: 'Carrossel Landing Page',
        items: [
          {
            item_id: item.id,
            item_name: item.name,
            affiliation: this.channelName,
            item_brand: item.brand,
            item_category: item.category,
            item_category2: item.area || this.defaultArea,
            price: item.price,
          },
        ],
      },
    });
  }

  addViewItemEvent(item) {
    if (!item) return;

    this._clearEcommerceKey();

    this._setItemConversionInGlobalScope(item);

    this._addEventToDataLayer({
      event: 'view_item',
      ecommerce: {
        currency: 'BRL',
        value: item.price,
        items: [
          {
            item_id: item.id,
            item_name: item.name,
            affiliation: this.channelName,
            item_brand: item.brand,
            item_category: item.category,
            item_category2: item.area || this.defaultArea,
            price: item.price,
          },
        ],
      },
    });
  }

  addItemConversionEvent() {
    if (!window.itemConversionData) return;

    this._clearEcommerceKey();

    const { id, name, brand, category, area, price } =
      window.itemConversionData;

    this._addEventToDataLayer({
      event: 'add_to_cart',
      ecommerce: {
        currency: 'BRL',
        value: price,
        items: [
          {
            item_id: id,
            item_name: name,
            affiliation: this.channelName,
            item_brand: brand,
            item_category: category,
            item_category2: area || this.defaultArea,
            price,
          },
        ],
      },
    });
  }

  addClickEvent(event) {
    if (!event) return;

    this._clearEcommerceKey();

    this._addEventToDataLayer(event);
  }

  _addEventToDataLayer(event) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(event);
  }

  _setItemConversionInGlobalScope(itemConversionData) {
    window.itemConversionData = itemConversionData;
  }

  _clearEcommerceKey() {
    this._addEventToDataLayer({ ecommerce: null });
  }

  _getChannelName() {
    const channelNameWrapper = document.querySelector(
      "meta[name='auto_layer_dealer_name']",
    );

    if (!channelNameWrapper) return '';

    const channelName = channelNameWrapper.content;

    return channelName;
  }
}
